import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({ endPoint: 'segmentation', method: 'GET', body: null, token: token })
}
